<div class="content-wrapper">
    <div class="content-body">
        <section id="referral-calculator">
            <div class="row">
                <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    <h2 class="mt-5px">Referral Earnings Calculator</h2>
                </div>
            </div>
            <div class="row mt-3">
                <div class="col-12">
                    <div class="card">
                        <div class="container-fluid p-3">
                            <div class="row">
                                <div class="col-lg-4 col-md-6 col-sm-12 mt-2">
                                    <label>Max Reward Points (per referral)</label>
                                    <input type="number" class="form-control" placeholder="e.g. 10000"
                                           [(ngModel)]="referral.max_reward_points"/>
                                </div>
                                <div class="col-lg-4 col-md-6 col-sm-12 mt-2">
                                    <label>Max Referral Saving (&#8377;)</label>
                                    <input type="number" class="form-control" placeholder="e.g. 5000"
                                           [(ngModel)]="referral.max_saving_amount"/>
                                </div>
                                <div class="col-lg-4 col-md-6 col-sm-12 mt-2">
                                    <label>Referrals Slider - Increment Step</label>
                                    <input type="number" class="form-control" placeholder="e.g. 10"
                                           [(ngModel)]="referral.referrals_increment"/>
                                </div>
                                <div class="col-lg-4 col-md-6 col-sm-12 mt-2">
                                    <label>Referrals Slider - Min</label>
                                    <input type="number" class="form-control" placeholder="e.g. 50"
                                           [(ngModel)]="referral.min_referrals"/>
                                </div>
                                <div class="col-lg-4 col-md-6 col-sm-12 mt-2">
                                    <label>Referrals Slider - Max</label>
                                    <input type="number" class="form-control" placeholder="e.g. 1000"
                                           [(ngModel)]="referral.max_referrals"/>
                                </div>
                                <div class="col-lg-4 col-md-6 col-sm-12 mt-2"></div>
                                <div class="col-lg-4 col-md-6 col-sm-12 mt-2">
                                    <label>Months Slider - Min</label>
                                    <input type="number" class="form-control" placeholder="e.g. 1"
                                           [(ngModel)]="referral.min_months"/>
                                </div>
                                <div class="col-lg-4 col-md-6 col-sm-12 mt-2">
                                    <label>Months Slider - Max</label>
                                    <input type="number" class="form-control" placeholder="e.g. 12"
                                           [(ngModel)]="referral.max_months"/>
                                </div>
                            </div>

                            <h6 class="mt-4 font-weight-600">Referral Badge Tiers</h6>
                            <div class="row d-none d-md-flex">
                                <div class="col-lg-3 col-md-3"><label>Badge</label></div>
                                <div class="col-lg-4 col-md-4"><label>Min Referrals</label></div>
                                <div class="col-lg-5 col-md-5"><label>Range Label</label></div>
                            </div>
                            <div class="row mt-2 align-items-center" *ngFor="let tier of referralBadgeTiers">
                                <div class="col-lg-3 col-md-3 col-sm-12">
                                    <input type="text" class="form-control" [ngModel]="tier.name" disabled/>
                                </div>
                                <div class="col-lg-4 col-md-4 col-sm-12 mt-2 mt-md-0">
                                    <input type="number" class="form-control" placeholder="Min Referrals"
                                           [(ngModel)]="tier.minReferrals"/>
                                </div>
                                <div class="col-lg-5 col-md-5 col-sm-12 mt-2 mt-md-0">
                                    <input type="text" class="form-control" placeholder="e.g. 100-499 referrals"
                                           [(ngModel)]="tier.rangeLabel"/>
                                </div>
                            </div>

                            <div class="row mt-4">
                                <div class="col-12">
                                    <button type="button" class="btn btn-primary" [disabled]="submitting"
                                            (click)="save()">
                                        Save Referral Calculator Settings
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</div>
